<template>
  <div class="container">
    <h2 class="text-center title"> {{ $t('home.our_services.title') }}</h2>
    <p class="text-center description">
      {{ $t('home.our_services.description') }}
    </p>
    <div class="row g-3 main-row">
      <ServicesCards />
    </div>
  </div>
</template>
<script>
import ServicesCards from './ourservices/servicesCards.vue';

export default {
  components: {
    ServicesCards
  }
}
</script>

<style scoped>
/* Ensure the container class applies correctly */
.container {
  margin-top: 40px;
}

/* General Text Styles */
.title {
  font-size: 36px;
  font-weight: 500;
}

.description {
  font-size: 18px;
  font-weight: 400;
  margin-top: 25px;
}

h6.section-title {
  font-size: 28px;
  font-weight: 500;
  margin-bottom: 21px;
}

.content {
  margin-bottom: 24px;
}

/* Layout Styling */
.main-row {
  margin-top: 40px;
}

.text-content-container {
  padding-top: 50px;
}

.image-box {
  border-radius: 20px;
  overflow: hidden;
  margin-bottom: 20px;
}


</style>
